import styled from '@emotion/styled';
import { mediaQuery, responsiveFontSize } from '@presentation/styles';

export const Wrapper = styled.div`
  height: 100%;
  width: 100%;
`;

export const Section = styled.section`
  margin-bottom: 50px;
  text-align: center;
  width: 100%;
  background: white;
  border-radius: 8px;
  box-shadow: 0 10px 18px 0 rgba(0, 0, 0, 0.06);
`;

export const ImageWrapper = styled.div`
  position: absolute;
  left: -30px;
  top: -83px;
  width: 100px;
  z-index: 1;
  img {
    width: 100%;
  }

  ${mediaQuery('small')} {
    left: 0;
  }
`;

export const Subsection = styled.div`
  padding: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;

  &:not(:first-of-type) {
    border-top: ${(props) => `1px solid ${props.theme.color.light.shade}`};
  }
`;

export const Text = styled.p`
  margin: 0;
  margin-top: 16px;
  margin-bottom: 16px;
`;

export const Subtitle = styled.div`
  ${responsiveFontSize(24, 2)};
  font-weight: 700;
  margin: 0 auto 20px auto;
  max-width: 350px;
  color: ${(props) => props.theme.color.dark.shade};
`;

export const BackButtonWrapper = styled.div`
  display: block;
  margin-right: auto;
  color: ${(props) => props.theme.color.light.shade};
`;

export const FormWrapper = styled.div`
  width: 100%;
  max-width: 450px;
`;
